// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "(max-width: 1024px) and (min-width: 601px)";
var _5 = "title-3o9dc";
var _6 = "wrapper-3QUwQ";
var _7 = "price-1Sz-E";
var _8 = "flight-2hjxD";
var _9 = "iconChoosed-27WyP";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "tablet_only", _5 as "title", _6 as "wrapper", _7 as "price", _8 as "flight", _9 as "iconChoosed" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "tablet_only": _4, "title": _5, "wrapper": _6, "price": _7, "flight": _8, "iconChoosed": _9 }
